import { useCallback, useEffect, useRef, useState } from "react";

export const useDebouncedValue = (value, delay = 400) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timeoutId);
  }, [value, delay]);

  return debounced;
};

export const useHoverDelay = (delay = 120) => {
  const timer = useRef(null);

  const clear = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
  }, []);

  const schedule = useCallback(
    (callback) => {
      clear();
      timer.current = setTimeout(() => {
        timer.current = null;
        callback();
      }, delay);
    },
    [clear, delay]
  );

  useEffect(() => () => clear(), [clear]);

  return { schedule, clear };
};
